import "core-js/modules/es.array.concat";

var getDividerClassNames = function getDividerClassNames(divider) {
  var side = divider.side,
      _divider$width = divider.width,
      width = _divider$width === void 0 ? 1 : _divider$width,
      _divider$color = divider.color,
      color = _divider$color === void 0 ? 'light' : _divider$color;
  return "Box-divider--".concat(color, "-").concat(side, "-").concat(width);
};

export default getDividerClassNames;